// Klienten på siden: Freemi har ét fælles design for alle virksomheder (farver og skrift i styles.css). Klienten markeres
// kun på <body data-klient>, så logo og navn kan vises; Freemi-konsollen (platformen) har ingen klient.
export function anvendKlientTema(slug: string | null) {
  if (typeof document === 'undefined') return;
  if (slug) document.body.dataset.klient = slug;
  else delete document.body.dataset.klient;
}
